/** Horizontal or vertical divider line. Wraps React Aria Separator. */
import {
  Separator as AriaSeparator,
  type SeparatorProps as AriaSeparatorProps,
} from 'react-aria-components';
import { cn } from '@/foundation/utils/cn';

interface SeparatorProps extends AriaSeparatorProps {
  className?: string;
}

export function Separator({ className, orientation = 'horizontal', ...props }: SeparatorProps) {
  return (
    <AriaSeparator
      orientation={orientation}
      className={cn(
        'bg-[var(--f-border)]',
        orientation === 'horizontal' ? 'h-px w-full' : 'w-px h-full',
        className
      )}
      {...props}
    />
  );
}
